<template>
  <div class="agreement-wrap">
    <!-- 顶部导航 -->
    <div class="header">
      <span class="back" @click="$router.back()">&lt; 返回</span>
      <h2>乘风快购用户协议</h2>
    </div>
    <div class="content">
      <p class="time">生效日期：2026年07月10日</p>
      <p>欢迎您使用乘风快购平台（以下简称“本平台”），本平台为外卖线上订购、线下即时配送服务平台，由乘风快购运营主体提供服务。在注册、登录、下单、使用平台全部功能前，请您仔细阅读本《乘风快购用户协议》全部条款。</p>
      <p>您点击“同意”、注册账号、下单、浏览、支付、点餐等任一使用行为，即代表您已完整阅读、理解并同意接受本协议全部约束；若您不同意任意条款，请立即停止使用本平台。</p>

      <h3>第一条 平台服务说明</h3>
      <p>1.1 乘风快购提供线上餐饮、生鲜果蔬、商超零售、药品等商品线上选购、订单支付、线下骑手即时配送、售后维权、会员权益、优惠券等综合外卖服务。</p>
      <p>1.2 平台仅作为信息展示与交易撮合中介，商品由入驻商家提供，配送服务由平台骑手/第三方配送团队提供，平台不直接生产、销售商品。</p>
      <p>1.3 平台区分三类用户：消费者用户、入驻商家、配送骑手，不同身份适用对应补充规则，本协议通用约束所有用户。</p>

      <h3>第二条 账号注册与使用规范</h3>
      <p>2.1 账号注册需提供本人真实手机号完成验证，一个手机号仅可绑定一个用户账号，禁止多人共用、租借、售卖账号。</p>
      <p>2.2 用户需妥善保管账号密码、短信验证码，因自身泄露、转借账号产生的订单损失、财产风险由用户自行承担。</p>
      <p>2.3 禁止使用他人身份信息、虚假手机号注册账号；禁止恶意批量注册、刷券、刷单、恶意退款等违规行为。平台有权对违规账号限制下单、冻结、注销。</p>
      <p>2.4 未成年人需监护人陪同阅读协议并同意后方可使用，未成年人大额消费监护人可申请核实退款。</p>

      <h3>第三条 订单、商品与配送规则</h3>
      <p>3.1 用户下单时需准确填写收货地址、联系方式，地址错误、电话无人接听导致配送失败，损失由用户承担。</p>
      <p>3.2 商家负责商品制作、保质、包装，商品变质、缺漏、错发由商家承担售后责任；骑手负责按时配送，超时、撒漏、丢失按平台售后规则处理。</p>
      <p>3.3 生鲜、餐饮熟食类商品一经送达无质量问题不支持无理由退款；存在变质、异物、漏送可上传凭证申请售后。</p>
      <p>3.4 配送范围、起送价、配送费、满减优惠券由商家与平台共同设定，下单前页面公示即有效，下单视为认可价格规则。</p>

      <h3>第四条 支付、优惠券与会员</h3>
      <p>4.1 平台支持微信支付、支付宝等合规支付渠道，所有支付资金由正规第三方支付机构清算，平台不截留用户支付款项。</p>
      <p>4.2 平台发放满减券、折扣券、会员红包存在使用期限、使用门槛，过期自动失效，不可折现、不可转让；恶意套券平台有权收回优惠并限制账号。</p>
      <p>4.3 乘风快购会员享有专属红包、免配送费、优先售后等权益，会员自动续费用户可随时在个人中心关闭自动续费。</p>

      <h3>第五条 用户禁止行为</h3>
      <p>用户不得实施以下行为，一经发现平台可限制功能、封禁账号并追究赔偿：</p>
      <ul>
        <li>恶意差评、虚假投诉、批量刷单套取优惠；</li>
        <li>辱骂、骚扰商家、骑手、平台客服；</li>
        <li>利用平台漏洞盗取优惠券、恶意退款牟利；</li>
        <li>发布涉黄、涉赌、暴力、造谣、违法广告内容；</li>
        <li>使用外挂、脚本、爬虫批量操作平台；</li>
        <li>盗用他人账号、冒用他人信息下单。</li>
      </ul>

      <h3>第六条 知识产权</h3>
      <p>乘风快购文字、Logo、页面设计、文案、软件代码、活动素材知识产权均归平台所有；未经书面许可，禁止复制、篡改、商用、二次分发。商家上传菜品图片、店铺素材知识产权由商家自行负责。</p>

      <h3>第七条 免责说明</h3>
      <p>7.1 因地震、暴雨、交通管制、疫情等不可抗力导致配送延迟、商家停业，平台不承担赔付责任，可协助用户办理退款。</p>
      <p>7.2 网络故障、手机设备问题、第三方支付渠道故障造成下单失败、支付异常，平台仅协助核查，不承担额外赔偿。</p>
      <p>7.3 商品口味、个人主观喜好不属于质量问题，不支持售后赔付。</p>

      <h3>第八条 协议修改</h3>
      <p>平台可根据业务调整更新本协议，更新后将在APP/网页公告展示，用户继续使用即视为接受新版协议；若不接受可停止使用并注销账号。</p>

      <h3>第九条 争议解决</h3>
      <p>因本协议产生纠纷，双方优先通过平台客服协商；协商不成，提交平台运营主体所在地人民法院诉讼解决。</p>

      <div class="end-tip">
        <p>如有疑问，可联系乘风快购在线客服或客服热线：19867383325</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserAgreement",
  data() {
    return {};
  },
  mounted() {
    // 页面加载置顶
    window.scrollTo(0, 0);
  }
}
</script>

<style scoped>
.agreement-wrap {
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
}
.header {
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 14px 16px;
  box-shadow: 0 1px 4px #eee;
  z-index: 99;
}
.back {
  color: #007aff;
  font-size: 16px;
  margin-right: 20px;
  cursor: pointer;
}
h2 {
  font-size: 18px;
  margin: 0;
  color: #333;
}
.content {
  width: min(920px, calc(100% - 32px)); box-sizing: border-box;
  padding: clamp(20px, 4vw, 48px);
  background: #fff;
  margin: 18px auto 40px; border-radius: 16px;
  line-height: 1.9; font-size: 15px;
  color: #444;
  text-align: left; box-shadow: 0 8px 30px rgba(30,40,50,.06);
}
.content p { margin: 0 0 14px; text-indent: 2em; }
.content .time { text-align: center; text-indent: 0; }
.time {
  color: #999;
  font-size: 13px;
  margin-bottom: 10px;
}
h3 {
  font-size: 16px;
  color: #222;
  margin: 20px 0 8px;
}
ul {
  padding-left: 20px;
  margin: 8px 0;
}
li {
  margin: 6px 0;
}
.end-tip {
  margin-top: 30px;
  padding-top: 15px;
  border-top: 1px solid #eee;
  color: #666;
}
.header h2 { flex: 1; text-align: center; padding-right: 76px; }
@media(max-width:600px){.content{width:100%;margin:0;border-radius:0;padding:22px 18px}.header{padding-top:max(14px,env(safe-area-inset-top))}.content p{text-indent:0}.header h2{padding-right:58px}}
</style>
